import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceLimitFragment = { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string, limitedResources?: { __typename?: 'LimitedResources', workspaces?: { __typename?: 'LimitedResource', limit53?: number | null } | null } | null } };

export const WorkspaceLimit = /*#__PURE__*/ gql`
    fragment WorkspaceLimit on Account {
  id
  subscription {
    id
    limitedResources {
      workspaces {
        limit53
      }
    }
  }
}
    ` as unknown as DocumentNode<WorkspaceLimitFragment, unknown>;

        

        
export const useWorkspaceLimitFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceLimitFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<WorkspaceLimitFragment>({
    fragment: WorkspaceLimit,
    fragmentName: 'WorkspaceLimit',
    ...options,
  });
};
  
        